/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Securitylevel1Inputs */

const de__field_securitylevel1 = /** @type {(inputs: _Field_Securitylevel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheitsstufe`)
};

/**

* @param {_Field_Securitylevel1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_securitylevel1 = /** @type {((inputs?: _Field_Securitylevel1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Securitylevel1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_securitylevel1(inputs)
});
export { _field_securitylevel1 as "_field_securityLevel" }